import {ReactComponent as ModelOutline} from "assets/image/Layout/ObjectPanel/ic_model_outline.svg";
import {ReactComponent as ModelSolid} from "assets/image/Layout/ObjectPanel/ic_model_solid.svg";
import {ReactComponent as AssetOutline} from "assets/image/Layout/ObjectPanel/ic_asset_outline.svg";
import {ReactComponent as AssetSolid} from "assets/image/Layout/ObjectPanel/ic_asset_solid.svg";
import {ReactComponent as LayerOutline} from "assets/image/Layout/ObjectPanel/ic_layer_outline.svg";
import {ReactComponent as LayerSolid} from "assets/image/Layout/ObjectPanel/ic_layer_solid.svg";
import {ReactComponent as MyOutline} from "assets/image/Layout/ObjectPanel/ic_my_outline.svg";
import {ReactComponent as MySolid} from "assets/image/Layout/ObjectPanel/ic_my_solid.svg";
import {ReactComponent as FavoritesOutline} from "assets/image/Layout/ObjectPanel/ic_favorites_outline.svg";
import {ReactComponent as FavoritesSolid} from "assets/image/Layout/ObjectPanel/ic_favorites_solid.svg";
import {ReactComponent as ScriptOutline} from "assets/image/Layout/ObjectPanel/ic_script_outline.svg";
import {ReactComponent as ScriptSolid} from "assets/image/Layout/ObjectPanel/ic_script_solid.svg";
import {ReactComponent as SnippetOutline} from "assets/image/Layout/ObjectPanel/ic_snippet_outline.svg";
import {ReactComponent as SnippetSolid} from "assets/image/Layout/ObjectPanel/ic_snippet_solid.svg";
import {MENU} from "../../constants";

export const worldMenuList = [
  {iconDefault: <ModelOutline />, iconSelected: <ModelSolid />, name: MENU.MODEL},
  {iconDefault: <AssetOutline />, iconSelected: <AssetSolid />, name: MENU.ASSET},
  {iconDefault: <LayerOutline />, iconSelected: <LayerSolid />, name: MENU.LAYER},
  {iconDefault: <MyOutline />, iconSelected: <MySolid />, name: MENU.MY},
  {iconDefault: <FavoritesOutline />, iconSelected: <FavoritesSolid />, name: MENU.FAVORITES},
];

export const codeMenuList = [
  {iconDefault: <ScriptOutline />, iconSelected: <ScriptSolid />, name: MENU.SCRIPT},
  {iconDefault: <LayerOutline />, iconSelected: <LayerSolid />, name: MENU.LAYER},
  // {iconDefault: <SnippetOutline />, iconSelected: <SnippetSolid />, name: MENU.SNIPPET},
];
